import { render, staticRenderFns } from "./Zlxg.vue?vue&type=template&id=532faa06&scoped=true"
import script from "./Zlxg.vue?vue&type=script&lang=js"
export * from "./Zlxg.vue?vue&type=script&lang=js"
import style0 from "./Zlxg.vue?vue&type=style&index=0&id=532faa06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532faa06",
  null
  
)

export default component.exports